import { Action } from '../action';
import { AuthState } from './state';
import { AuthType } from './action';

export const initialState: AuthState = {
    token: undefined,
};

export const authReducer = (state: AuthState | undefined, action: Action): AuthState => {
    state = state ?? initialState;

    switch (action.type) {
        case AuthType.TokenProvided:
            return { ...state, token: action.token };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
